export const validationEmail = value => {
  if (value?.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/)) {
    return true;
  } else {
    return false;
  }
};
